import React from 'react'
import { Switch } from 'react-router'
import { Route } from 'react-router-dom'
import BusinessSettingsWrapper from '../pages/Business/Settings/Wrapper'
import Users from '../pages/Business/Users/Users'
import BusinessSignUp from '../pages/Auth/BusinessSignUp'
import BusinessLogin from '../pages/Auth/BusinessLogin'
import UserDetailsPage from '../pages/Business/UserDetails/UserDetails'
import BusinessRoute from '../components/Authentication/BusinessRoute'

const BusinessWrapper = ({ match }) => {
    const { path } = match
    return (
        <>
            <Switch>
                <BusinessRoute
                    path={`${path}/settings`}
                    component={BusinessSettingsWrapper}
                />
                <BusinessRoute path={`${path}/users`} component={Users} exact />
                <BusinessRoute
                    path={`${path}/users/:userId`}
                    component={UserDetailsPage}
                />
                <Route path={`${path}/sign-up`} component={BusinessSignUp} />
                <Route path={`${path}/sign-in`} component={BusinessLogin} />
            </Switch>
        </>
    )
}

export default BusinessWrapper
